import styled from 'styled-components';
import { LoadingMaskContentMixin } from '../../mixins/components/LoadingMaskMixin';
import { doNotForwardTransientProp } from '../../util/doNotForwardTransientProp';
export var StyledLoadingMaskContent = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: doNotForwardTransientProp(['loading'])
}).withConfig({
  displayName: "StyledLoadingMaskContent",
  componentId: "c11n-8-111-1__sc-1brcmz6-0"
})(["", ""], LoadingMaskContentMixin);